import { ResidenceType } from '../quotes.types'

export const residenceTypeVolume: Partial<Record<any, number>> = {
  [ResidenceType.StorageUnit5By5]: 200,
  [ResidenceType.StorageUnit5By10]: 300,
  [ResidenceType.StorageUnit10By20]: 1000,
}
